import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Cookies from "js-cookie"
import styled from "styled-components"
import { useIntl } from "gatsby-plugin-react-intl"

import { Container } from "../components/Grid"

import { daysFromNow } from "../helpers"
import { media } from "../styles"

const NoticeWrapper = styled.div`
  background: ${({ theme }) => theme.brandPrimaryMedium};
  color: ${({ theme }) => theme.brandSecondaryDark};
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 1px;
  padding: 30px 0;
  position: relative;

  p {
    font-size: inherit;
    line-height: 1.5;

    a {
      color: ${({ theme }) => theme.brandPrimaryDark};

      &:hover {
        color: ${({ theme }) => theme.brandLinksHover};
      }
    }
  }

  @media ${media.md} {
    font-size: 18px;
  }
`

const Close = styled.button`
  appearance: none;
  background: none;
  border: none;
  color: ${({ theme }) => theme.brandPrimaryDark};
  cursor: pointer;
  margin: 0;
  padding: 5px;
  position: absolute;
  right: 5px;
  top: 5px;
  transition: color ${({ theme }) => theme.transitionTime};

  &:hover {
    color: ${({ theme }) => theme.brandLinksHover};
  }

  @media ${media.sm} {
    right: 10px;
    top: 10px;
  }
`

const Notice = ({ id, children, pageId, hideOnPages, isCloseable }) => {
  const [isHidden, setIsHidden] = useState(true)
  const intl = useIntl()

  useEffect(() => {
    if (
      Cookies.get(`${id}_banner_closed`) !== "1" &&
      (hideOnPages ? hideOnPages.indexOf(pageId) === -1 : true) &&
      pageId !== "404" &&
      !pageId.match(/^maintenance/)
    ) {
      setIsHidden(false)
    }
  }, [id, hideOnPages, pageId])

  const closeBanner = () => {
    Cookies.set(`${id}_banner_closed`, 1, {
      expires: daysFromNow(30),
      path: "/",
      httpOnly: false,
    })

    setTimeout(() => {
      setIsHidden(true)
    }, 300)
  }

  return !isHidden ? (
    <NoticeWrapper id={`notice-${id}`}>
      <Container>{children}</Container>
      {isCloseable && (
        <Close
          onClick={closeBanner}
          aria-label={intl.formatMessage({ id: "close" })}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <polygon
              fill="currentColor"
              fillRule="evenodd"
              points="14 1.4 12.6 0 7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 7 8.4 12.6 14 14 12.6 8.4 7"
            />
          </svg>
        </Close>
      )}
    </NoticeWrapper>
  ) : (
    ""
  )
}

Notice.propTypes = {
  children: PropTypes.node.isRequired,
  hideOnPages: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string.isRequired,
  isCloseable: PropTypes.bool.isRequired,
  pageId: PropTypes.string.isRequired,
}

export default Notice
